import React from 'react';
import PropTypes from 'prop-types';
import CompetitionsContent from '~scenes/sport/generic/competitions';
import PocTabs from '~spa/Components/PocTabs/PocTabs';
import { getTabs } from '~spa/Components/PocTabs/Utils/Context';
import { GENERIC_SPORTS_HEADER } from './constants';

class Competitions extends React.Component {
    render () {
        const {
            sportSlug,
        } = this.props.match.params;

        const [
            localizedSportSlug,
        ] = this.props.location.state.context.originalUrl;

        const gtmAttribute = sportSlug + GENERIC_SPORTS_HEADER;
        const tabs = getTabs(sportSlug, localizedSportSlug, { isCompetitions: true });

        return (
            <React.Fragment>
                <PocTabs tabs={tabs} gtmAttribute={gtmAttribute} />
                <CompetitionsContent sportSlug={sportSlug} localizedSportSlug={localizedSportSlug} />
            </React.Fragment>
        );
    }
}

Competitions.propTypes = {
    match: PropTypes.object.isRequired,
    location: PropTypes.object.isRequired,
};

export default Competitions;
